import React, {useState, useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useLocation} from 'react-router-dom';
import Popup from '@frontend/ui-kit/Components/Popup';
import {closePopup, openPopup, getPopupState} from '../../slices/shared';

// @ts-ignore
const withPopup = (popupId: string) => Component => {
    const WithPopup = (props: any) => {
        // FYI: Children can be too big for saving in Store (e.g. "Wallet") which leads to the crash
        // of opening the popup. It's the reason why better to save children in the local state (Slava, 07.01.2024)
        const [children, setChildren] = useState(null);
        const location = useLocation();
        const popupState = useSelector(getPopupState);
        const {isOpened, isOnlyManualClose = false} = popupState[popupId] ?? {};
        const dispatch = useDispatch();

        const onOpen = (params: any) => {
            const {children, ...restParams} = params;

            setChildren(children);
            dispatch(openPopup({id: popupId, ...restParams}));
        };

        const onClose = () => {
            if (props.onClosePopup) {
                props.onClosePopup();
            }

            setChildren(null);
            dispatch(closePopup({id: popupId}));
        };

        const onDestroy = () => isOpened ? onClose() : false;
        // @ts-ignore
        useEffect(() => {
            onDestroy();

            return () => onDestroy();
        }, [location]);

        const popupProps = {
            ...popupState[popupId],
            children,
            popupId,
            onClose: !isOnlyManualClose ? onClose : null
        };
        const componentProps = {
            ...props,
            openPopup: onOpen,
            closePopup: onClose
        };

        return (
            <React.Fragment>
                {children && <Popup {...popupProps}/>}

                <Component {...componentProps}/>
            </React.Fragment>
        );
    };

    return WithPopup;
};

export default (popupId: string) => withPopup(popupId);
